import React from 'react';


function Header (){
    return(
        <div className='header'> <h3>Home</h3> </div>   
    )
}

export default Header 